import {Component} from '@angular/core';
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {ReactiveFormsModule} from "@angular/forms";
import {Page} from "../../../../../generated-model/model";

@Component({
  selector: 'app-uc-advance-history',
  standalone: true,
  imports: [
    GtNgDatepickerModule,
    NgbPagination,
    NotFoundComponent,
    ReactiveFormsModule
  ],
  templateUrl: './uc-advance-history.component.html',
  styleUrl: './uc-advance-history.component.scss'
})
export class UcAdvanceHistoryComponent {
  pageData: Page<any> = {number: 0, size: 10, content: []};

  ngOnInit(): void {
    this.search();
  }

  search($event: number = 0) {
  }

  clear() {
    this.pageData = {number: 0, size: 10, content: []};
    this.search();
  }
}
